<template>
    <div :style="style" ref="lavContainer"></div>
</template>

<script>
import lottie from 'lottie-web';

export default {
  name: "Lottie",
  props: {
    options: {
      type: Object,
      required: true
    },
    height: Number,
    width: Number,
  },

  data() {
    return {
      style: {
        width: this.width ? `${this.width}px` : '100%',
        height: this.height ? `${this.height}px` : '100%',
        overflow: 'hidden',
        margin: '0 auto'
      }
    }
  },

  mounted() {
    this.anim = lottie.loadAnimation({
        container: this.$refs.lavContainer,
        renderer: 'svg',
        loop: this.options.loop !== false,
        autoplay: this.options.autoplay !== false,
        animationData: this.options.animationData,
        rendererSettings: this.options.rendererSettings
      }
    );
    this.$emit('animCreated', this.anim)
  }
}
</script>
<!--<template>-->
<!--  <div class="lottie"-->
<!--    ref="lottie" id="lottie"></div>-->

<!--</template>-->

<!--<script lang="ts">-->
<!--import { Component, Prop, Emit, Vue } from 'vue-property-decorator'-->
<!--const LottieWeb: any = require('lottie-web')-->

<!--@Component-->
<!--export default class Lottie extends Vue {-->
<!--  @Prop({-->
<!--    type: Boolean,-->
<!--    required: false,-->
<!--    default: true-->
<!--  }) private loop!: boolean-->

<!--  @Prop({-->
<!--    type: Boolean,-->
<!--    required: false,-->
<!--    default: true-->
<!--  }) private autoPlay!: boolean-->

<!--  @Prop({-->
<!--    type: String,-->
<!--    required: false,-->
<!--    default: 'lottie'-->
<!--  }) private name!: string-->

<!--  @Prop({-->
<!--    type: Object,-->
<!--    required: true,-->
<!--    default: () => {-->
<!--      return {}-->
<!--    }-->
<!--  }) private animationData!: {}-->

<!--  private lottieObj: any = LottieWeb-->

<!--  private get options (): {} {-->
<!--    return {-->
<!--      // container: this.$refs.lottie,-->
<!--      container:  document.getElementById('lottie'),-->
<!--      renderer: 'svg',-->
<!--      loop: this.loop,-->
<!--      autoplay: this.autoPlay,-->
<!--      name: this.name,-->
<!--      animationData: this.animationData-->
<!--    }-->
<!--  }-->

<!--  @Emit('created')-->
<!--  emitCreated (lottie: any) { }-->

<!--  private mounted () {-->
<!--    console.log(this.options)-->
<!--    this.lottieObj.loadAnimation(this.options)-->
<!--    this.emitCreated(this.lottieObj)-->
<!--  }-->
<!--}-->

<!--</script>-->
<!--<style>-->
<!--.lottie {-->
<!--  width: 100%;-->
<!--  height: 100%;-->
<!--}-->
<!--</style>-->
